
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/special-classes",
      function () {
        return require("private-next-pages/[authorID]/special-classes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]/special-classes"])
      });
    }
  